import React from 'react';
import { ValidationReport } from '../types/validation';

interface SummaryCardProps {
  report: ValidationReport;
}

export const SummaryCard: React.FC<SummaryCardProps> = ({ report }) => {
  const { overall, validators, timestamp, commit, dataSource, householdsTotal } = report;
  const matchPercent = (overall.matchRate * 100).toFixed(1);

  const formatNumber = (n: number) => n.toLocaleString();

  return (
    <div className="summary-card">
      <div className="summary-header">
        <div>
          <h2>Validation Summary</h2>
          {dataSource && (
            <span className="data-source">{dataSource} &middot; {formatNumber(householdsTotal || 0)} households</span>
          )}
        </div>
        <span className="timestamp">
          {new Date(timestamp).toLocaleString()} &middot; {commit}
        </span>
      </div>

      <div className="summary-stats">
        <div className="stat">
          <span className="stat-value">{matchPercent}%</span>
          <span className="stat-label">Consensus Match Rate</span>
        </div>
        <div className="stat">
          <span className="stat-value">{formatNumber(overall.totalMatches)}</span>
          <span className="stat-label">of {formatNumber(overall.totalTests)} tests passing</span>
        </div>
        {overall.meanAbsoluteError !== undefined && (
          <div className="stat">
            <span className="stat-value">${overall.meanAbsoluteError.toFixed(2)}</span>
            <span className="stat-label">Mean Absolute Error</span>
          </div>
        )}
        {overall.averageReward !== undefined && (
          <div className="stat">
            <span className="stat-value">{overall.averageReward.toFixed(2)}</span>
            <span className="stat-label">Avg Reward Signal</span>
          </div>
        )}
      </div>

      <div className="validators-status">
        <h3>Validators</h3>
        <div className="validator-badges">
          {validators.map((v) => (
            <span
              key={v.name}
              className={`validator-badge ${v.available ? 'available' : 'unavailable'}`}
            >
              {v.available ? '✓' : '○'} {v.name}
              {v.version && <span className="version">v{v.version}</span>}
              {v.householdsCovered && (
                <span className="coverage">{formatNumber(v.householdsCovered)} HH</span>
              )}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
